//Main
import vue from "vue"
import vapi from "vuex-rest-api"
import vuex from "vuex"
import store from "./index.js"

vue.use(vuex);


//store
const rol = new vapi({
    baseURL: `${process.env.VUE_APP_REST}/api/rol`,
    state: {
        Aroles: []
    }
}).get({
    action: "get_roles",
    onSuccess: (state, payload) => {
        state.Aroles = payload.data;
    }
}).put({
    action: "Postrol", 
    onSuccess: (state, payload) => {
        store.dispatch("mensaje/set_success", payload);
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
    }
}).getStore();

rol.getters = {
    groles: state => {
        return state.Aroles;
    }
}

export default rol;


